import { Link } from "react-router-dom";

const sections = [
  {
    h: "Acceptance of Terms",
    b: [
      "By accessing or using the Blessings Connection LLC website (\"the Site\"), you agree to be bound by these Terms & Conditions and all applicable laws and regulations.",
      "If you do not agree with any part of these terms, please do not use the Site.",
    ],
  },
  {
    h: "About Blessings Connection LLC",
    b: [
      "Blessings Connection LLC is a United States registered online retailer that sells new books, textbooks, educational materials, and related reading products.",
      "Our business address and contact information are provided at the bottom of this page and on the About Us page.",
    ],
  },
  {
    h: "Products and Pricing",
    b: [
      "All products listed on the Site are subject to availability. We reserve the right to limit quantities, discontinue products, or refuse orders at our discretion.",
      "Prices are listed in United States Dollars (USD) and are subject to change without notice.",
      "We make reasonable efforts to display accurate product information, including titles, descriptions, prices, and stock availability. In the event of a pricing or description error, we reserve the right to cancel the affected order and issue a refund.",
    ],
  },
  {
    h: "Orders and Payments",
    b: [
      "When you place an order, you make an offer to purchase the selected items at the listed price. Orders are subject to acceptance and are confirmed only after payment has been successfully received and verified.",
      "Payments are processed by our payment provider, Stripe. By placing an order, you authorize us to charge the applicable amount to your selected payment method.",
      "We reserve the right to cancel or refuse any order that we believe was placed fraudulently or in violation of these Terms.",
    ],
  },
  {
    h: "Shipping",
    b: [
      "Orders are shipped in accordance with our Shipping & Cancellations Policy. Delivery estimates provided on the Site are estimates only and are not guaranteed.",
    ],
  },
  {
    h: "Returns and Refunds",
    b: [
      "Returns and refunds are governed by our Return & Refund Policy.",
    ],
  },
  {
    h: "Account Responsibility",
    b: [
      "If you create an account on the Site, you are responsible for maintaining the confidentiality of your login credentials and for all activity that occurs under your account.",
      "You agree to provide accurate and complete information when creating an account and to keep that information up to date.",
    ],
  },
  {
    h: "Intellectual Property",
    b: [
      "All content on the Site, including text, graphics, logos, images, and software, is the property of Blessings Connection LLC or its content suppliers and is protected by applicable intellectual property laws.",
      "You may not copy, reproduce, republish, or distribute any content from the Site without our prior written permission.",
    ],
  },
  {
    h: "Prohibited Use",
    b: [
      "You agree not to use the Site for any unlawful purpose, to attempt unauthorized access to any part of the Site, or to interfere with the operation of the Site or the experience of other users.",
    ],
  },
  {
    h: "Limitation of Liability",
    b: [
      "The Site and its content are provided on an \"as is\" and \"as available\" basis. To the fullest extent permitted by law, Blessings Connection LLC disclaims all warranties, whether express or implied, regarding the Site and the products offered.",
      "Blessings Connection LLC will not be liable for any indirect, incidental, or consequential damages arising from your use of the Site or products purchased through the Site.",
    ],
  },
  {
    h: "Governing Law",
    b: [
      "These Terms & Conditions are governed by and construed in accordance with the laws of the State of Wyoming and applicable United States federal law, without regard to conflict of law principles.",
    ],
  },
  {
    h: "Changes to These Terms",
    b: [
      "We may update these Terms & Conditions from time to time. When we do, we will revise the \"Last Updated\" date at the top of this page.",
      "Your continued use of the Site after any changes constitutes acceptance of the updated Terms.",
    ],
  },
];

export default function Terms() {
  const updated = "December 2025";
  return (
    <div className="pt-28 md:pt-32 pb-20 bg-[#F9F6F0]" data-testid="terms-page">
      <div className="max-w-[800px] mx-auto px-6">
        <h1 className="text-3xl md:text-4xl font-semibold text-slate-900 text-center mb-3" data-testid="terms-title">
          Terms &amp; Conditions
        </h1>
        <p className="text-sm text-slate-500 text-center mb-10" data-testid="terms-eyebrow">
          Last Updated: {updated}
        </p>

        <div className="space-y-6 text-base leading-relaxed text-slate-700">
          {sections.map((s, idx) => (
            <section key={s.h} data-testid={`terms-section-${String(idx + 1).padStart(2, "0")}`}>
              <h2 className="text-xl font-medium mt-8 mb-3 text-slate-900">{s.h}</h2>
              <div className="space-y-3">
                {s.b.map((p, i) => <p key={i}>{p}</p>)}
              </div>
              {s.h === "Shipping" && (
                <p className="mt-3">
                  <Link to="/shipping" className="text-slate-900 underline hover:text-[#7A2021]">
                    Read the Shipping &amp; Cancellations Policy →
                  </Link>
                </p>
              )}
              {s.h === "Returns and Refunds" && (
                <p className="mt-3">
                  <Link to="/returns" className="text-slate-900 underline hover:text-[#7A2021]">
                    Read the Return &amp; Refund Policy →
                  </Link>
                </p>
              )}
            </section>
          ))}

          <section data-testid="terms-section-contact">
            <h2 className="text-xl font-medium mt-8 mb-3 text-slate-900">Contact Us</h2>
            <p>If you have any questions about these Terms & Conditions, please contact:</p>
            <div className="mt-3">
              <p className="font-medium text-slate-900">Blessings Connection LLC</p>
              <p>
                Email:{" "}
                <a
                  href="mailto:customerservice@blessingsconnection.com"
                  className="text-slate-900 underline hover:text-[#7A2021]"
                  data-testid="terms-contact-email"
                >
                  customerservice@blessingsconnection.com
                </a>
              </p>
              <p className="mt-2">Our customer support team aims to respond within 1–2 business days.</p>
            </div>
          </section>

          <div className="border-t border-slate-200 pt-6 mt-10">
            <p className="text-sm text-slate-500">
              Blessings Connection LLC · blessingsconnection.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
